import { Box, BoxProps, ModBox, Spacer, TextNew } from '@jfs/ui-new'
import { GradientButton } from '../../components/GradientButton'

import { Dispatch, SetStateAction } from 'react'
import ActionsMenu from '../../components/ActionMenu/ActionsMenu'

interface PosHeaderProps {
  title: string
  fetchDataOnChange: () => void
  onRefresh: () => void
  filterVisible: boolean
  setFilterVisible: Dispatch<SetStateAction<boolean>>
  exportRecords: () => void
  enableFilter: any
  showCalendar: boolean
  showRefresh: boolean
}

export const MakerCheckerHeader = ({
  title,
  fetchDataOnChange,
  onRefresh,
  filterVisible,
  setFilterVisible,
  exportRecords,
  enableFilter,
  showCalendar,
  showRefresh,
}: PosHeaderProps) => {
  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <TextNew title={title} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          enableFilter={enableFilter}
          showCalendar={showCalendar}
          defaultPage={1}
          type="aadharRedactionChecker"
          showRefresh={showRefresh}
          onRefresh={onRefresh}
          showSearch={false}
          showSearchByEntityId={false}
        />
        <Spacer size={8} />
        <Box alignItems={'flex-end'}>
          <GradientButton
            title={'Export To Excel'}
            onPress={exportRecords}
            width={148}
            height={32}
            borderRadius={4}
          />
        </Box>
      </ModBox>
    </Box>
  )
}

const styles = {
  header: {
    flexDirection: 'row',
    p: 16,
    w: '100%',
  } as BoxProps,
}
